import AppMediumType from "@/models/Settings/AppMediums/AppMediumType";

export default (appMediumType: AppMediumType) => {
    let returnVal = "Undefined";
    switch (appMediumType) {
        case AppMediumType.FiApiServiceAccount:
            returnVal = "FI API Service Account";
            break;
        case AppMediumType.UxApiCustomerAccess:
            returnVal = "UX API Customer Access";
            break;
        case AppMediumType.UxApiServiceAccount:
            returnVal = "UX API Service Account";
            break;
    }
    return returnVal;
}